import React from 'react';
import PropTypes from 'prop-types';
import MomentUtils from '@date-io/moment';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { ThemeProvider } from '@material-ui/core/styles';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import { Provider, observer } from 'mobx-react';
import { useErrorBoundary } from 'use-error-boundary';

import { App } from './app';

import { SegmentProvider } from 'modules/analytics';
import { Page404 } from './app/pages/404';
import { LoginPage, LogoutPage, PasswordRecoveryPage, AuthActionPage } from './app/pages/auth';
import { GlobalErrorPage } from './app/pages/errors';
import { RegistrationPage } from './app/pages/registration';
import { WelcomePage } from './app/pages/onboarding';
import { ScrollTop } from 'components/utils';
import { theme } from 'theme/base';

import { AssessmentsStore, AssessmentAnswersStore } from 'modules/assessments';
import { TopicsStore } from 'modules/topics';
import { AuthService } from 'modules/auth';
import { HttpService } from 'modules/http';

import './App.css';

export const AppWrapper = observer((services) => {
  const { ErrorBoundary } = useErrorBoundary();

  return (
    <Router>
      <ScrollTop />
      <ErrorBoundary renderError={({ error }) => <GlobalErrorPage error={error} />}>
        <Provider { ...services }>
          <SegmentProvider apiKey={process.env.REACT_APP_SEGMENT_WRITE_KEY}>
            <MuiPickersUtilsProvider utils={MomentUtils}>
              <ThemeProvider theme={theme}>
                <Routes>
                  <Route exact path='/login' element={<LoginPage />} />
                  <Route exact path='/logout' element={<LogoutPage />} />
                  <Route exact path='/signup' element={<RegistrationPage />} />
                  <Route exact path='/password-recovery' element={<PasswordRecoveryPage />} />
                  <Route exact path='/auth/action' element={<AuthActionPage />} />
                  <Route path='/welcome' element={<WelcomePage />} />
                  <Route path='/404' element={<Page404 />} />
                  <Route path='/error' element={<GlobalErrorPage />} />
                  <Route path='*' element={<App />} />
                  <Route element={<Page404 />} />
                </Routes>
              </ThemeProvider>
            </MuiPickersUtilsProvider>
          </SegmentProvider>
        </Provider>
      </ErrorBoundary>
    </Router>
  );
});

AppWrapper.propTypes = {
  httpService: PropTypes.instanceOf(HttpService).isRequired,
  authService: PropTypes.instanceOf(AuthService).isRequired,
  assessmentsStore: PropTypes.instanceOf(AssessmentsStore).isRequired,
  topicsStore: PropTypes.instanceOf(TopicsStore).isRequired,
  assessmentAnswersStore: PropTypes.instanceOf(AssessmentAnswersStore).isRequired,
};
